import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isMobileMenuOpen: false,
  additionalSidebars: {}
};

const slice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleMobileMenu(state, { payload }) {
      state.isMobileMenuOpen = payload !== undefined ? payload : !state.isMobileMenuOpen;
    },
    toggleAdditionalSidebar(state, { payload }) {
      const { sidebarKey, isOpen } = payload;
      if (sidebarKey) {
        // Initialize the sidebar state if it doesn't exist
        if (!state.additionalSidebars.hasOwnProperty(sidebarKey)) {
          state.additionalSidebars[sidebarKey] = false;
        }
        state.additionalSidebars[sidebarKey] = isOpen !== undefined ? isOpen : !state.additionalSidebars[sidebarKey];
      }
    },
    setSidebarDefaultState(state, { payload }) {
      const { sidebarKey, defaultOpen = false } = payload;
      if (sidebarKey && !state.additionalSidebars.hasOwnProperty(sidebarKey)) {
        state.additionalSidebars[sidebarKey] = defaultOpen;
      }
    },
    // Legacy support - maps to 'chat' sidebar for backward compatibility
    toggleLegacyAdditionalSidebar(state, { payload }) {
      if (!state.additionalSidebars.hasOwnProperty('chat')) {
        state.additionalSidebars.chat = false;
      }
      state.additionalSidebars.chat = payload !== undefined ? payload : !state.additionalSidebars.chat;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { toggleMobileMenu, toggleAdditionalSidebar, setSidebarDefaultState, toggleLegacyAdditionalSidebar } =
  slice.actions;
